import React, { useCallback } from 'react';
import propTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Grid, Button, InputAdornment, TextField, CircularProgress } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { Formik, Form } from 'formik';
import classNames from 'classnames';
import styles from './styles';
import { drawerTypes } from '../../pages/Equipment/components/helpers/drawerTypes';
import { debounce } from 'lodash';
import { SEARCH_DEBOUNCE_MS } from './constants';

const TodayFiltersBar = ({
  classes,
  openDrawer,
  updateSearchValue,
  noFilters,
  scrollTodayWorklog,
  isTodayLoading,
  isDynamicSearch,
  onSearchStart,
}) => {
  const debouncedOnChange = useCallback(
    debounce((value) => {
      updateSearchValue(value);
    }, SEARCH_DEBOUNCE_MS),
    []
  );

  return (
    <Formik
      initialValues={{ searchValue: '' }}
      onSubmit={(values, { isSubmitting }) => {
        if (isSubmitting) return;
        onSearchStart?.();
        updateSearchValue(values.searchValue);
      }}
    >
      {({ values, setFieldValue }) => (
        <Grid
          container
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          style={{ paddingTop: '8px', paddingBottom: '8px' }}
        >
          <Grid item xs={noFilters ? 12 : 12} md={noFilters ? 12 : 8} xl={noFilters ? 12 : 7}>
            <Form autoComplete="off" className={classes.formFlex}>
              <div className={classes.todaySearch}>
                <TextField
                  type="text"
                  name="searchValue"
                  variant="outlined"
                  placeholder="Search"
                  value={values.searchValue}
                  onChange={(e) => {
                    const input = e.target.value;
                    setFieldValue('searchValue', input);
                    if (isDynamicSearch) {
                      onSearchStart?.();
                      debouncedOnChange(input);
                    }
                  }}
                  className={classes.todaySearch}
                  inputProps={{ 'aria-label': 'Search' }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <div className={classes.searchIcon}>
                          <SearchIcon />
                        </div>
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
            </Form>
          </Grid>
          <Grid item xs={4} md={2} xl={2}>
            <Button
              variant="contained"
              color="secondary"
              className={classNames(classes.todayToggleFiltersBtn, false && classes.isToday)}
              onClick={() => scrollTodayWorklog()}
              disableTouchRipple
              loading
              disabled={isTodayLoading}
            >
              {isTodayLoading ? <CircularProgress style={{ width: 20, height: 20 }} /> : 'Today'}
            </Button>
          </Grid>

          {!noFilters && (
            <Grid item xs={8} md={2} xl={3}>
              <Button
                variant="contained"
                color="secondary"
                className={classes.todayToggleFiltersBtn}
                onClick={openDrawer(drawerTypes.filters, true)}
                disableTouchRipple
              >
                <i
                  className={classNames('fa fa-sliders', classes.filtersIcon)}
                  aria-hidden="true"
                />
                Filters
              </Button>
            </Grid>
          )}
        </Grid>
      )}
    </Formik>
  );
};

TodayFiltersBar.propTypes = {
  classes: propTypes.object.isRequired,
  openDrawer: propTypes.func.isRequired,
  updateSearchValue: propTypes.func.isRequired,
  onSearchStart: propTypes.func,
  noFilters: propTypes.bool,
};

export default withStyles(styles)(TodayFiltersBar);
